module.exports = __webpack_public_path__ + "static/hero1.f24ca70d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pc/hero1.jpg
// module id = 505
// module chunks = 35783957827783